import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getLocalStorage, setLocalStorage } from '@/utils/tools'
import { getMenuTree } from '@/pages/admin/menu/api'

const menuTreeCacheKey = 'cache-menu-tree'

export const removeFirstMenuLevel = (treeList) => {
  if (!Array.isArray(treeList)) return []
  return treeList.reduce((items, item) => {
    if (item?.children && item.children.length > 0) {
      items.push(...item.children)
    }
    return items
  }, [])
}

export const fetchGetMenuTreeAsync = createAsyncThunk(
  'menu/fetchGetMenuTreeAsync',
  () => {
    const menuTreeCache = getLocalStorage(menuTreeCacheKey)
    return axios
      .get(getMenuTree(menuTreeCache?.version))
      .then((response) => {
        const resp = response?.data
        if (resp === null) return []
        if (resp.data === null && resp.version === menuTreeCache?.version) {
          return menuTreeCache.data ?? []
        } else {
          setLocalStorage(menuTreeCacheKey, resp)
          return resp.data ?? []
        }
      })
      .catch((err) => {
        throw Error('读取菜单缓存失败')
      })
  }
)

const menuSlice = createSlice({
  name: 'menu',
  initialState: {
    menuTree: [],
    realMenuTree: []
  },
  reducers: {
    setMenuTree(state, action) {
      state.menuTree = action.payload
    },
    setRealMenuTree(state, action) {
      state.realMenuTree = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetMenuTreeAsync.pending, (state) => {
        state.menuTree = []
        state.realMenuTree=[]
      })
      .addCase(fetchGetMenuTreeAsync.fulfilled, (state, action) => {
        state.menuTree = removeFirstMenuLevel(action.payload)
        state.realMenuTree = action.payload
      })
  },
})

export const { setMenuTree,setRealMenuTree } = menuSlice.actions
//获取所有部门树
export const getAllMenuTree = (state) => state.menu.menuTree
export const getAllRealMenuTree = (state) => state.menu.realMenuTree
export default menuSlice.reducer
